'use strict';
var angular = require('angular');
var newShippingAddressController = /** @class */ (function () {
    /*@ngInject*/
    function newShippingAddressController($log, $scope, $state, $q, Util, AddressService, SettingsService, Auth) {
        'ngInject';
        var _this = this;
        this.$log = $log;
        this.$state = $state;
        this.$scope = $scope;
        this.$q = $q;
        this.util = Util;
        this.addressService = AddressService;
        this.settingService = SettingsService;
        this.address = {
            'recipientName': '',
            'line1': '',
            'line2': '',
            'city': '',
            'countryCode': 'US',
            'countryName': 'United States',
            'isDefault': false
        };
        this.country = {};
        this.countryList = [];
        this.stateList = [];
        this.postalCodeRequired = false;
        $scope.$on('resetNewAddressForm', function () {
            _this.setupForm();
            $scope.addrForm.$setPristine();
            $scope.addrForm.$setUntouched();
        });
    }
    newShippingAddressController.prototype.$onInit = function () {
        this.setupForm();
    };
    newShippingAddressController.prototype.setupForm = function () {
        var _this = this;
        this.address.recipientName = '';
        this.address.line1 = '';
        this.address.line2 = '';
        var usAddress = {
            countryCode: 'US',
            countryName: 'United States',
            postalCodeRegex: '^\\d{5}(?:[-\\s]*\\d{4})?$',
            postalCodeRequired: true,
            regionCodeRequired: true
        };
        this.country = usAddress;
        this.postalCodePattern = new RegExp(this.country.postalCodeRegex);
        this.postalCodeRequired = this.country.postalCodeRequired;
        this.addressService.getRegionsForCountry('US').then(function (response) {
            _this.stateList = response.data.response.currentPage;
            _this.stateList = _this.stateList.sort(_this.sortStateList);
        });
        if (!this.showUsOnly) {
            this.addressService.getShippingCountries().then(function (response) {
                _this.countryList = response.data.response.currentPage || [];
                // move United States to the top of the country list
                for (var i = 0; i < _this.countryList.length; i++) {
                    if (_this.countryList[i].countryCode === 'US') {
                        _this.countryList.splice(0, 0, _this.countryList.splice(i, 1)[0]);
                        break;
                    }
                }
            });
        }
        else {
            this.countryList = [usAddress];
        }
    };
    newShippingAddressController.prototype.sortStateList = function (state1, state2) {
        var name1 = state1.regionName.toLowerCase();
        var name2 = state2.regionName.toLowerCase();
        if (name1 > name2)
            return 1;
        if (name1 < name2)
            return -1;
        return 0;
    };
    newShippingAddressController.prototype.searchCountry = function (query) {
        if (query) {
            return this.countryList.filter(function (country) {
                var name = country['countryName'].toLowerCase();
                return (name.indexOf(query.toLowerCase()) === 0);
            });
        }
        return this.countryList;
    };
    newShippingAddressController.prototype.countryChange = function () {
        var _this = this;
        this.state = {};
        this.address.city = '';
        this.address.regionName = '';
        this.address.regionCode = '';
        this.address.postalCode = '';
        if (this.country && this.country.countryCode) {
            this.address.countryCode = this.country.countryCode;
            this.address.countryName = this.country.countryName;
            this.postalCodeRequired = this.country.postalCodeRequired;
            this.addressService.getRegionsForCountry(this.country.countryCode)
                .then(function (response) {
                _this.stateList = response.data.response.currentPage;
                _this.stateList = _this.stateList.sort(_this.sortStateList);
            });
        }
    };
    newShippingAddressController.prototype.stateChange = function () {
        if (this.state && this.state.regionCode) {
            this.address.regionName = this.state.regionName;
            this.address.regionCode = this.state.regionCode;
        }
    };
    newShippingAddressController.prototype.$onChanges = function (changes) {
        this.setupForm();
    };
    return newShippingAddressController;
}());
export default newShippingAddressController;
//# sourceMappingURL=new-shipping-address.controller.js.map